import { Component, Input } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { OnInit } from "@angular/core";

@Component({
  selector: "futuros-error",
  templateUrl: "./futuros-error.component.html",
  styleUrls: ["./futuros-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class FuturosErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ColumnsFutures: string[] = [
    "accountManagerName",
    "accountManagerDocument",
    "portfolioDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioName",
    "portfolioB3Account",
    "operationTypeId",
    "tradingDate",
    "amount",
    "unitPrice",
    "percentageDiscount",
    "paperCode",
    "paperSerie",
    "broker",
    "brokerDocument",
    "brokerCode",
    "brokerAccount",
    "annotations",
  ];

  ngOnInit(): void {}
}
